import React from 'react';
import AirlineDetailPage from '../components/AirlineDetailPage';
import { AIR_FRANCE } from '../data/airlinesData';

export default function AirFrancePage() {
  return <AirlineDetailPage airline={AIR_FRANCE} />;
}
